import { PrismicButton } from '@components/PrismicButton';
import { CtaButtonSliceTwoCta } from '@monofront/slice-machine/prismicio-types';
import { isFilled } from '@prismicio/client';

export const CtaButtonTwoCta = ({ primary }: CtaButtonSliceTwoCta) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-self-stretch desktop:tw-flex-row desktop:tw-self-auto">
        <PrismicButton
          field={primary.primary_cta}
          className="tw-self-stretch desktop:tw-self-auto"
        />
        <PrismicButton
          field={primary.secondary_cta}
          className="tw-self-stretch desktop:tw-self-auto"
        />
      </div>

      {isFilled.keyText(primary.caption) && (
        <p className="tw-lf-caption-regular">{primary.caption}</p>
      )}
    </div>
  );
};
